import {useRef, type ReactNode} from 'react'
import {Button} from '@/components/ui/button'
import {DescargarEvidencia} from '@/components/descargar-evidencia'
import {EVIDENCE_ACCEPT, evidenceKindLabel, formatSize, type Evidence} from '@/hooks/sgsst/evidencias/use-evidence'

export function UploadTrigger({
  label,
  progress,
  testId,
  onPick,
  // PQ-7b: el enlace público acepta menos tipos; el servidor lo exige igual.
  accept = EVIDENCE_ACCEPT,
}: {
  label: string
  progress: number | null
  testId: string
  onPick: (files: FileList | null) => void
  accept?: string
}) {
  const inputRef = useRef<HTMLInputElement>(null)
  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        hidden
        data-testid={`${testId}-input`}
        onChange={(e) => {
          onPick(e.target.files)
          if (inputRef.current) inputRef.current.value = ''
        }}
      />
      {progress !== null ? (
        <div className="h-1.5 w-40 overflow-hidden rounded-full bg-secondary">
          <div className="h-full rounded-full bg-primary transition-all" style={{width: `${progress}%`}} />
        </div>
      ) : (
        <Button size="sm" variant="outline" data-testid={`${testId}-upload`} onClick={() => inputRef.current?.click()}>
          {label}
        </Button>
      )}
    </>
  )
}

export function EvidenceListItem({
  item,
  ruta,
  testId,
  trailing,
}: {
  item: Evidence
  ruta: string
  testId: string
  trailing?: ReactNode
}) {
  return (
    <li
      className="flex flex-wrap items-center gap-2 rounded-lg border border-border px-2.5 py-1.5"
      data-testid={testId}>
      <span className="rounded-sm bg-secondary px-1.5 py-0.5 font-mono text-[10px] font-semibold text-muted-foreground uppercase">
        {evidenceKindLabel(item.content_type)}
      </span>
      <DescargarEvidencia
        ruta={ruta}
        className="min-w-0 flex-1 truncate text-xs font-medium text-foreground hover:text-primary">
        {item.filename}
      </DescargarEvidencia>
      <span className="font-mono text-[10px] text-muted-foreground">{formatSize(item.size_bytes)}</span>
      {trailing}
    </li>
  )
}
